import React from 'react'

const FiltroTexto = ({column}) => {
  return (
    <input
      className="flex w-full justify-evenly items-center rounded-md text-cendiatra p-5px"
      value={column.getFilterValue() ?? ''}
      onChange={(e) => {
        column.setFilterValue(e.target.value || undefined)
      }}
      placeholder={`Buscar..`}
    />
  )
}

export default FiltroTexto
